// extracted by mini-css-extract-plugin
export var container = "_2a-0";
export var disabled = "_2a-4";
export var fullWidth = "_2a-3";
export var lined = "_2a-1";
export var selected = "_2a-5";
export var tab = "_2a-2";